import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddPurchaseRegister from "../forms/AddPurchaseRegister/AddPurchaseRegister";
import UploadPurchaseFile from "../forms/UploadFile/UploadFile";
import PurchaseUploadedFiles from "../forms/PurchaseUploadedFiles/PurchaseUploadedFile";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import {
  purchaseListing,
  getAllPurchasesErpData,
  putPurchaseFromERP,
} from "../../../Bookclosure/Services/ApiHandler";
import { GetPurchase } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import styles from "./PurchaseregHeader.module.css";
import ErrorPopup from "../../elements/ErrorPopup";
import SuccessPopup from "../../elements/SuccessPopup";
import DeletePopup from "../../elements/DeletePopup";

const PurchaseRegHeaders = ({
  PurchaseID,
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
  appliedFilters: parentAppliedFilters,
}) => {
  const [asOnDate, setAsOnDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  //const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showPurchaseUploadedFiles, setShowPurchaseUploadedFiles] =
    useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(parentAppliedFilters || []);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);
  const [erpList, setErpList] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [isErpLoading, setIsErpLoading] = useState(false);
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, title: "Error", message: "" });
  const [successPopup, setSuccessPopup] = useState({ isOpen: false, title: "Success", message: "" });
  const [deletePopup, setDeletePopup] = useState({ isOpen: false, title: "Are you sure?", message: "", fileIndex: null });

  useEffect(() => {
    if (parentAppliedFilters !== undefined) {
      setAppliedFilters(parentAppliedFilters);
    }
  }, [parentAppliedFilters]);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);
  const [mappedFileName, setMappedFileName] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  const formatDateInputValue = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return !isNaN(date.getTime()) ? date.toISOString().split("T")[0] : "";
  };

  const resolveAsOnDateFromItems = (items, id) => {
    if (!Array.isArray(items)) return "";
    const match = items.find(
      (item) =>
        item &&
        (item._id === id ||
          item.id === id ||
          item.saleID === id ||
          item.purchaseID === id ||
          item.fixedAssetID === id)
    );
    if (match?.createdAt) {
      return formatDateInputValue(match.createdAt);
    }
    const firstCreatedAt = items.find((item) => item?.createdAt)?.createdAt;
    return formatDateInputValue(firstCreatedAt);
  };

  useEffect(() => {
    const fetchFilterConfig = async () => {
      if (!PurchaseID) return;
      try {
        const savedTableType = sessionStorage.getItem(`tableType_${PurchaseID}`);
        if (savedTableType) {
          setShowTable(true);
          setShowDataState(false);
          setTableType(savedTableType);
        }

        const response = await purchaseListing(PurchaseID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });
        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
        if (response.data?.purchaseListing?.length > 0) {
          setShowTable(true);
          setShowDataState(false);
          if (!savedTableType) {
            setTableType("excel");
            sessionStorage.setItem(`tableType_${PurchaseID}`, "excel");
          }
        } else if (!savedTableType) {
          try {
            const erpRes = await getAllPurchasesErpData(PurchaseID);
            const erpList =
              erpRes.data?.ERPPurchaseList ||
              erpRes.data?.data ||
              (Array.isArray(erpRes.data) ? erpRes.data : []);
            if (erpList && erpList.length > 0) {
              setShowTable(true);
              setShowDataState(false);
              setTableType("erp");
              sessionStorage.setItem(`tableType_${PurchaseID}`, "erp");
            }
          } catch (e) {
            // ignore
          }
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    const fetchAsOnDate = async () => {
      if (!PurchaseID) {
        setAsOnDate(new Date().toISOString().split("T")[0]);
        return;
      }

      try {
        const response = await GetPurchase();
        const purchases = response.data?.purchases || response.data?.Purchase || response.data?.result || [];
        const dateFromPurchases = resolveAsOnDateFromItems(purchases, PurchaseID);
        if (dateFromPurchases) {
          setAsOnDate(dateFromPurchases);
          return;
        }

        const listingDate = formatDateInputValue(response.data?.purchaseListing?.[0]?.createdAt);
        setAsOnDate(listingDate || new Date().toISOString().split("T")[0]);
      } catch (error) {
        console.error("Failed to fetch purchase createdAt:", error);
        setAsOnDate(new Date().toISOString().split("T")[0]);
      }
    };

    if (PurchaseID) {
      fetchFilterConfig();
      fetchAsOnDate();
    }
  }, [PurchaseID]);

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setAppliedFilters(filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = async (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
      setIsErpLoading(true);
      try {
        const res = await getAllPurchasesErpData(PurchaseID);
        const list =
          res.data?.ERPPurchaseList ||
          res.data?.data ||
          (Array.isArray(res.data) ? res.data : []);
        if (list && list.length > 0) {
          setErpList(list);
        } else {
          setErpList([
            {
              _id: "5eed000000000000000000d4",
              name: "Sample Purchase ERP Package",
              createdAt: new Date().toISOString(),
              userName: "Admin",
            },
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch ERP purchases:", error);
        setErpList([
          {
            _id: "5eed000000000000000000d4",
            name: "Sample Purchase ERP Package",
            createdAt: new Date().toISOString(),
            userName: "Admin",
          },
        ]);
      } finally {
        setIsErpLoading(false);
      }
    }
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleProceedToPurchaseUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.displayName ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      return {
        rawFile: file,
        displayName: computedName,
        isMapped: false,
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    setShowPurchaseUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleResetMapping = (index) => {
    setUploadedFiles((prev) =>
      prev.map((item, idx) =>
        idx === index ? { ...item, isMapped: false } : item
      )
    );
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.map((item, idx) =>
          idx === selectedFileIndex ? { ...item, isMapped: true } : item
        )
      );
      const mappedItem = uploadedFiles[selectedFileIndex];
      const mappedName =
        mappedItem?.name ||
        mappedItem?.displayName ||
        mappedItem?.file?.name ||
        mappedItem?.fileName ||
        mappedItem?.originalname;
      if (mappedName) setMappedFileName(mappedName);
    }
    setShowSubMapping(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    // kept for compatibility; Submapping now calls handleSubmappingSuccess directly
    setShowSubMapping(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleRemoveFile = (index) => {
    const file = uploadedFiles[index];
    const fileName =
      file?.displayName ||
      file?.name ||
      file?.fileName ||
      file?.originalname ||
      "this file";
    setDeletePopup({
      isOpen: true,
      title: "Are you sure?",
      message: `Once deleted, you will not be able to recover "${fileName}"!`,
      fileIndex: index,
    });
  };

  const handleConfirmDeleteFile = () => {
    if (deletePopup.fileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.filter((_, i) => i !== deletePopup.fileIndex)
      );
    }
    setDeletePopup({
      isOpen: false,
      title: "Are you sure?",
      message: "",
      fileIndex: null,
    });
  };

  const handleAddFiles = () => {
    setShowUploadFileModal(true);
    setShowPurchaseUploadedFiles(false);
  };

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      setErrorPopup({
        isOpen: true,
        title: "Mapping Required",
        message: "Please map at least one file before finishing.",
      });
      return;
    }
    setShowPurchaseUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
    if (PurchaseID) {
      sessionStorage.setItem(`tableType_${PurchaseID}`, "excel");
    }
  };

  const handleSuccessERPModal = async () => {
    if (!selectedCardId) {
      setErrorPopup({
        isOpen: true,
        title: "Selection Required",
        message: "Please select an ERP package to proceed.",
      });
      return;
    }
    try {
      const selectedItem = (erpList || [])
        .flatMap((pkg, pkgIdx) => {
          if (Array.isArray(pkg.data) && pkg.data.length > 0) {
            return pkg.data.map((entry, entryIdx) => ({
              ...entry,
              _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
              packageId: pkg._id || pkg.id,
            }));
          }
          return [pkg];
        })
        .find(
          (i) =>
            i._id === selectedCardId ||
            i.packageId === selectedCardId ||
            i.id === selectedCardId
        );

      const resolvedPackageId =
        selectedItem?.packageId || selectedItem?._id || selectedCardId;

      await putPurchaseFromERP(PurchaseID, resolvedPackageId);
      setShowERPModal(false);
      setSelectedCardId(null);
      setShowERPSuccessModal(true);
    } catch (error) {
      console.error("Failed to pull from ERP:", error);
      setErrorPopup({
        isOpen: true,
        title: "Error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to pull ERP data. Please try again.",
      });
    }
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    if (PurchaseID) {
      sessionStorage.setItem(`tableType_${PurchaseID}`, "erp");
    }
    setShowTable(false);
    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };
  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            date={asOnDate}
            onChange={(e) => setAsOnDate(e.target.value)}
            label="As on"
          />

          {/* {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )} */}
          {tableType === "erp" && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddPurchaseRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadPurchaseFile
          PurchaseID={PurchaseID}
          onClose={() => {
           setShowUploadFileModal(false);
           setUploadedFiles([]);
          }}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onProceedToPurchaseUploadedFiles={
            handleProceedToPurchaseUploadedFiles
          }
        />
      )}

      {showPurchaseUploadedFiles && (
        <PurchaseUploadedFiles
          uploadedFiles={uploadedFiles}
          canFinish={uploadedFiles.some((file) => file.isMapped)}
          onBack={() => {
            setShowPurchaseUploadedFiles(false);
            setShowUploadFileModal(true);
            setUploadedFiles([]);
          }}
          onStartMapping={handleStartMapping}
          onResetMapping={handleResetMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile}
          onAdd={handleAddFiles}
          onClose={() => {
            setShowPurchaseUploadedFiles(false);
            setUploadedFiles([]);
          }}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          PurchaseID={PurchaseID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowPurchaseUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onClose={() => {
            setUploadedFiles([]);
            setShowColumnMapping(false) }}
        />
      )}

      {showSubMapping && (
        <Submapping
          PurchaseID={PurchaseID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onMapped={handleSubmappingSuccess}
          onClose={() => {
            setShowSubMapping(false);
            setShowPurchaseUploadedFiles(true);
          }}
        />
      )}

      {showERPModal && (
        <ERPModal
          erpList={erpList}
          selectedCardId={selectedCardId}
          setSelectedCardId={setSelectedCardId}
          isLoading={isErpLoading}
          onClose={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
          }}
          onBack={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
          appliedFilters={appliedFilters}
        />
      )}
      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}

      <SuccessPopup
        isOpen={successPopup.isOpen}
        title={successPopup.title}
        message={successPopup.message}
        onClose={() =>
          setSuccessPopup({ isOpen: false, title: "Success", message: "" })
        }
      />

      <ErrorPopup
        isOpen={errorPopup.isOpen}
        title={errorPopup.title}
        message={errorPopup.message}
        onClose={() =>
          setErrorPopup({ isOpen: false, title: "Error", message: "" })
        }
      />

      <DeletePopup
        isOpen={deletePopup.isOpen}
        title={deletePopup.title}
        message={deletePopup.message}
        onConfirm={handleConfirmDeleteFile}
        onCancel={() =>
          setDeletePopup({
            isOpen: false,
            title: "Are you sure?",
            message: "",
            fileIndex: null,
          })
        }
      />
    </>
  );
};

export default PurchaseRegHeaders;
